import React from 'react';
import { useSelector } from 'react-redux';
import { ONBOARDING_ENABLED, SETUP_V2_ENABLED } from './flags';
import { setupRoleFor } from './setup/SetupContext';
import { openOnboardingLayer } from './ImportJobContext';
import { STARTER_MENUS, hasStarterMenu, salonBusinessType } from './starterMenus';
import './StarterScreen.css';

/**
 * Safety net for owners who closed setup (plan section 6): an empty catalogue
 * offers the starter menu for their trade, next to adding one by hand.
 */
export default function StarterEmptyState({ onAddService }) {
  const user = useSelector((s) => s.user);
  const type = salonBusinessType(user);
  const label = hasStarterMenu(type) ? STARTER_MENUS[type].label : '';
  // The starter menu puts services on everyone and makes the practice client:
  // the account holder's call, never a stylist's. Only with Set up with
  // Bailey on (staging): everywhere else it offers exactly as it always did.
  const isOwner = !SETUP_V2_ENABLED || setupRoleFor(user) === 'owner';
  return (
    <div className="obst-empty">
      <div className="obst-empty-title">No services yet</div>
      <p className="obst-empty-copy">
        {label
          ? `Start from a typical menu for ${label} and change the names, times and prices to match yours.`
          : 'Start from a typical menu and change the names, times and prices to match yours.'}
      </p>
      <div className="obst-empty-actions">
        {onAddService && <button type="button" className="obst-empty-btn" onClick={onAddService}>Add a service</button>}
        {ONBOARDING_ENABLED && isOwner && (
          <button type="button" className="obst-empty-btn obst-empty-btn--primary" onClick={() => openOnboardingLayer({ mode: 'setup', screen: 'menu' })}>
            Use a starter menu
          </button>
        )}
      </div>
    </div>
  );
}
